import { useI18n } from "@/api/i18n";
import { cn } from "@/libs/cn";
import type { SectorDraft } from "../../selector/types";

const I18N = "taxonomy.sector.summary" as const;

/**
 * «Salvando: 1 suggerito confermato · 2 rifiutati» under the selector, from the
 * draft against the saved profile (AC9). It says nothing at 0/0. The live
 * region stays mounted, empty and hidden, so a change is announced when it
 * fills. The surfaces pass the verb: «Salvando», or the onboarding one.
 */
export const SummaryRow = (props: {
  draft: SectorDraft;
  verb: string;
  class?: string;
}) => {
  const { t } = useI18n();
  const text = () => {
    const { confirmed, rejected } = props.draft.summary();
    const confirmedText =
      confirmed > 0
        ? t(confirmed === 1 ? `${I18N}.confirmed_one` : `${I18N}.confirmed`, {
            count: confirmed,
          })
        : "";
    const rejectedText =
      rejected > 0
        ? t(rejected === 1 ? `${I18N}.rejected_one` : `${I18N}.rejected`, {
            count: rejected,
          })
        : "";
    const params = {
      verb: props.verb,
      confirmed: confirmedText,
      rejected: rejectedText,
    };
    if (confirmedText && rejectedText) return t(`${I18N}.line`, params);
    if (confirmedText) return t(`${I18N}.confirmedOnly`, params);
    if (rejectedText) return t(`${I18N}.rejectedOnly`, params);
    return "";
  };

  return (
    <p
      aria-live="polite"
      class={cn("text-xs text-foreground/70 empty:hidden", props.class)}
    >
      {text()}
    </p>
  );
};
